// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"886fe187","732":"ab3dea90","977":"00cc0c1e"}[chunkId] + ".chunk.js";
};